module.exports = __webpack_public_path__ + "/images/ico-burger.fbad3ee.svg";